module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6GSOc"))).then(() => parcelRequire('d0iPb'));